import { render, staticRenderFns } from "./ButtonTwo.vue?vue&type=template&id=36956f8f&"
import script from "./ButtonTwo.vue?vue&type=script&lang=ts&"
export * from "./ButtonTwo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports